import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReactQuill from "react-quill";
import format from "date-fns/format";
import { useWindowTilesContext } from "desktopWindow/context/WindowTilesContext";
import { isMobile } from "react-device-detect";

type Editor = {
	selectedNote: any;
	onTextChange: any;
};

const NoteEditor: React.FC<Editor> = ({ selectedNote, onTextChange }) => {
	const classes = useStyles();
	const { MobileWindowResized } = useWindowTilesContext();
	const resizeToFullScreen = () => {
		MobileWindowResized("notes", true);
	};
	const restoreNoteWindowSize = () => {
		window.setTimeout(() => {
			MobileWindowResized("notes", false);
		}, 250);
	};
	return (
		<Grid item container direction="column" xs={isMobile ? 12 : 8}>
			<div className={classes.noteGridMaster}>
				<div className={classes.noteGrid}>
					<div className={classes.timer}>
						{selectedNote && (
							// TODO: #loc
							<div>{format(new Date(selectedNote.updatedAt), "dd-MMM-yyyy 'at' h:mm a")}</div>
						)}
					</div>
					{selectedNote ? (
						<ReactQuill
							theme="snow"
							modules={{
								toolbar: [
									[
										"bold",
										"italic",
										"underline",
										{
											color: [
												"#000000",
												"#e60000",
												"#ff9900",
												"#ffff00",
												"#008a00",
												"#0066cc",
												"#9933ff",
												"#ffffff",
												"#facccc",
												"#ffebcc",
												"#ffffcc",
												"#cce8cc",
												"#cce0f5",
												"#ebd6ff",
												"#bbbbbb",
												"#f06666",
												"#ffc266",
												"#ffff66",
												"#66b966",
												"#66a3e0",
												"#c285ff",
												"#888888",
												"#a10000",
												"#b26b00",
												"#b2b200",
												"#006100",
												"#0047b2",
												"#6b24b2",
												"#444444",
												"#5c0000",
												"#663d00",
												"#666600",
												"#003700",
												"#002966",
												"#3d1466",
											],
										},
										{ list: "bullet" },
									],
								],
							}}
							formats={["bold", "strike", "italic", "underline", "color", "list", "bullet", "indent"]}
							placeholder="New Note"
							value={selectedNote.text}
							onChange={debounce(onTextChange, 1000)}
							className={classes.editor}
							onFocus={resizeToFullScreen}
							onBlur={restoreNoteWindowSize}
						/>
					) : (
						<></>
					)}
				</div>
			</div>
		</Grid>
	);
};

function debounce(fn, delay) {
	let timeoutID;
	return function (...args) {
		if (timeoutID) clearTimeout(timeoutID);
		timeoutID = setTimeout(() => {
			fn(...args);
		}, delay);
	};
}

const useStyles = makeStyles((theme) => ({
	timer: {
		margin: "10px 0",
		color: "#717171",
		font: "normal normal normal 14px Tahoma",
		letterSpacing: "0px",
		fontWeight: 500,
		textAlign: "center",
		fontSize: "0.75rem",
	},
	noteGridMaster: {
		backgroundColor: "#fff",
		// height: "100%",
		flex: 1,
		position: "relative",
		[theme.breakpoints.down("mobile")]: {
			flexBasis: "100%",
			maxWidth: "100%",
		},
	},
	noteGrid: {
		flex: "auto",
		position: "absolute",
		height: "90%",
		width: "100%",
	},
	editor: {
		"& .ql-container.ql-snow": {
			border: "none",
			fontSize: "0.75rem",
		},
		"& .ql-toolbar.ql-snow": {
			borderRight: "none",
			borderLeft: "none",
		},
		height: "90%",
	},
}));

export default NoteEditor;
